/* unplugin-vue-components disabled */import __unplugin_components_2 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/FooterViews.vue';
import __unplugin_components_1 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/NavViews.vue';
import __unplugin_components_0 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/HeaderViews.vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup: function setup(__props) {
    var showPrint = ref(true);
    onMounted(function () {
      var router = useRouter();
      var route = useRoute();
      // if(route.fullPath=='/adminPrint'){
      //   showPrint.value=true
      // }else{
      //   showPrint.value=false
      // }
      route.fullPath == '/adminPrint' ? showPrint.value = false : showPrint.value = true;
      window.addEventListener('beforeunload', function () {
        sessionStorage.setItem('currentRoute', route.fullPath);
      });
      window.addEventListener('load', function () {
        var currentRoute = sessionStorage.getItem('currentRoute');
        if (currentRoute) {
          router.push(currentRoute);
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_HeaderViews = __unplugin_components_0;
      var _component_NavViews = __unplugin_components_1;
      var _component_router_view = _resolveComponent("router-view");
      var _component_FooterViews = __unplugin_components_2;
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(showPrint) ? (_openBlock(), _createBlock(_component_HeaderViews, {
        key: 0
      })) : _createCommentVNode("", true), _unref(showPrint) ? (_openBlock(), _createBlock(_component_NavViews, {
        key: 1
      })) : _createCommentVNode("", true), _createVNode(_component_router_view), _unref(showPrint) ? (_openBlock(), _createBlock(_component_FooterViews, {
        key: 2
      })) : _createCommentVNode("", true)], 64);
    };
  }
});